// extracted by mini-css-extract-plugin
module.exports = {"link":"LoginView_link__2oSQ4"};